import PropTypes from "prop-types"
import { DialogContent, DialogActions, Button, Alert } from "@mui/material"

export function ErrorDialog({ error, close }) {
  return <>
    <DialogContent className="update-experiment-dialog">
      <Alert severity="error">{error}</Alert>
    </DialogContent>
    <DialogActions>
      <Button color="secondary" onClick={close}>Close</Button>
    </DialogActions>
  </>
}

ErrorDialog.propTypes = {
  error: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
}
